var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.hideComponents)?_c('HeaderComponent'):_vm._e(),_vm._v(" "),_c('Transition',{attrs:{"mode":"out-in","name":"page"}},[_c('RouterView',{key:_vm.$route.fullPath})],1),_vm._v(" "),_c('ModalsComponent'),_vm._v(" "),_c('Notifications',{attrs:{"position":"bottom right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }